const experiencePostArray = [...document.querySelectorAll('.p-location__post')];
const postStyleCustomizeLength = experiencePostArray.length % 4;

let customizePost;

if(postStyleCustomizeLength === 0) {
  customizePost = [...document.querySelectorAll('.p-location__post:nth-last-of-type(-n+4)')];
  classAdd(customizePost, 'is-pb-border-hide');

} else if(postStyleCustomizeLength === 1) {
  customizePost = [...document.querySelectorAll('.p-location__post:nth-last-of-type(1)')];
  classAdd(customizePost, 'is-pb-border-hide');

} else if(postStyleCustomizeLength === 2) {
  customizePost = [...document.querySelectorAll('.p-location__post:nth-last-of-type(-n+2)')];
  classAdd(customizePost, 'is-pb-border-hide');

} else if(postStyleCustomizeLength === 3) {
  customizePost = [...document.querySelectorAll('.p-location__post:nth-last-of-type(-n+3)')];
  classAdd(customizePost, 'is-pb-border-hide');

}

function classAdd(array, className) {
  array.forEach((element) => {
    element.classList.add(className)
  })
}

const pageNumbersLinks = [...document.querySelectorAll('.page-numbers a')];

const pageNumbersHref = pageNumbersLinks.map(link => link.getAttribute('href'));


const addHash = '#location';

pageNumbersHref.forEach((e, index) => {
  if(e.indexOf('page')) {
    pageNumbersLinks[index].setAttribute('href', `${pageNumbersHref[index] + addHash}`)
  }
})